import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import it from './locales/it.json';

const supportedLanguages = ['de', 'en', 'fr', 'es', 'it'];

function normalizeLanguage(language) {
  if (!language || typeof language !== 'string') {
    return null;
  }

  return language.split('-')[0].toLowerCase();
}

function getDefaultLanguage() {
  const savedLanguage = normalizeLanguage(localStorage.getItem('language'));
  if (savedLanguage && supportedLanguages.includes(savedLanguage)) {
    return savedLanguage;
  }

  const browserLanguages = Array.isArray(navigator.languages) && navigator.languages.length > 0
    ? navigator.languages
    : [navigator.language];

  for (const language of browserLanguages) {
    const normalizedLanguage = normalizeLanguage(language);
    if (normalizedLanguage && supportedLanguages.includes(normalizedLanguage)) {
      return normalizedLanguage;
    }
  }

  return 'en';
}

i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
    fr: { translation: fr },
    es: { translation: es },
    it: { translation: it },
  },
  lng: getDefaultLanguage(),
  fallbackLng: 'en',
  supportedLngs: supportedLanguages,
  load: 'languageOnly',
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (language) => {
  const normalizedLanguage = normalizeLanguage(language) || 'en';
  localStorage.setItem('language', normalizedLanguage);
  document.documentElement.lang = normalizedLanguage;
});

document.documentElement.lang = normalizeLanguage(i18n.language) || 'en';

export default i18n;
